import { ELOQUENT } from 'config/constants';

/**
 * Get all users
 * @param {Object} query
 * @returns {Promise}
 */
export function getAllUsers(query) {
    return ELOQUENT.User.getAll(query);
}

/**
 * Get logged in user's profile data
 * @returns {Promise}
 */
export function getAuthedProfile() {
    return ELOQUENT.User.me();
}

/**
 * Update a user's profile data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateUserProfile(id, data) {
    return ELOQUENT.User.updateProfile(id, data);
}

/**
 * Update admin's profile data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateAdminData(id, data) {
    return ELOQUENT.User.updateOne(id, data);
}

/**
 * Get user roles
 * @returns {Promise}
 */
export function getUserRoles() {
    return ELOQUENT.User.getRoles();
}

/**
 * Create a new user
 * @param {Object} data
 * @returns {Promise}
 */
export function createNewUser(data) {
    return ELOQUENT.User.createOne(data);
}

/**
 * Update a user
 * @param {Number | String} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateAUser(id, data) {
    return ELOQUENT.User.updateOne(id, data);
}

/**
 * Delete a user
 * @param {Number | String} id
 * @returns {Promise}
 */
export function deleteAUser(id) {
    return ELOQUENT.User.deleteOne(id);
}

/**
 * Get all users role
 * @returns {Promise}
 */
export function getAllRole() {
    return ELOQUENT.Role.getAll();
}
